/**
 * Recharge Widget Pricing Handler
 * Updates prices for both original and custom Recharge widgets when variant changes
 */

function formatMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, '{{ shop.money_format }}');
  }

  const value = (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return value;
}

function updateRechargeWidgetPrices(variant, quantity = 1) {
  const appBlockContainer = document.querySelector('.shopify-block.shopify-app-block.recharge-subscription-widget');
  if (!appBlockContainer) return;

  const rechargeWidget = appBlockContainer.querySelector('.recharge-subscription-widget label.subscription-radio');
  if (!rechargeWidget) {
    setTimeout(() => updateRechargeWidgetPrices(variant, quantity), 200);
    return;
  }

  updateOriginalRechargeWidgetPrices(variant, quantity);

  const customWidget = appBlockContainer.querySelector('.subscription-widget');
  if (!customWidget) {
    setTimeout(() => generateRechargeWidgetHtml(), 200);
    return;
  }

  updateCustomWidgetPricesInPlace(customWidget, variant, quantity);
}

function updateCustomWidgetPricesInPlace(customWidget, variant, quantity) {
  // Update One-Time Purchase Price
  const oneTimePriceContainer = customWidget.querySelector('.one-time-purchase .subscribe-and-save-savings');
  if (oneTimePriceContainer) {
    const oneTimePrice = variant.price * quantity;
    const oneTimeCompareAtPrice = variant.compare_at_price * quantity;

    const priceParts = (oneTimePrice / 100).toFixed(2).split('.');
    const compareAtPriceParts = variant.compare_at_price ? (oneTimeCompareAtPrice / 100).toFixed(2).split('.') : null;

    let oneTimePriceHtml = '';
    if (variant.compare_at_price > variant.price) {
      // Show both discounted price and compare_at_price (strikethrough)
      oneTimePriceHtml = `
          <div class="product-price">
            <span class="currency">$</span>
        <span class="dollars">${priceParts[0]}</span>
        <span>.</span>
        <span class="cents">${priceParts[1]}</span>
          </div>
      <span class="compare-at-price">
        <div class="product-price">
          <span class="currency">$</span>
          <span class="dollars">${compareAtPriceParts[0]}</span>
          <span class="cents">${compareAtPriceParts[1]}</span>
        </div>
      </span>
      `;
    } else {
      // No discount, show regular price only
      oneTimePriceHtml = `
      <div class="product-price">
        <span class="currency">$</span>
        <span class="dollars">${priceParts[0]}</span>
        <span>.</span>
        <span class="cents">${priceParts[1]}</span>
      </div>
    `;
    }
    oneTimePriceContainer.innerHTML = oneTimePriceHtml;
  }

  // Update Subscription Price
  const subPriceContainer = customWidget.querySelector('.subscribe-and-save .subscribe-and-save-savings');
  if (subPriceContainer) {
    const subscriptionDiscount = getSubscriptionDiscountPercentage();
    const subscriptionPrice = variant.price * (1 - subscriptionDiscount) * quantity;
    const originalPrice = variant.price * quantity;

    let subPriceHtml = `
      <div class="product-price">
        <span class="currency">$</span>
        <span class="dollars">${(subscriptionPrice / 100).toFixed(2).split('.')[0]}</span>
        <span>.</span>
        <span class="cents">${(subscriptionPrice / 100).toFixed(2).split('.')[1]}</span>
      </div>
      <span class="compare-at-price">
        <div class="product-price">
          <span class="currency">$</span>
          <span class="dollars">${(originalPrice / 100).toFixed(2).split('.')[0]}</span>
          <span class="cents">${(originalPrice / 100).toFixed(2).split('.')[1]}</span>
        </div>
      </span>
    `;
    subPriceContainer.innerHTML = subPriceHtml;
  }

  // Update Button States
  const isAvailable = variant && variant.available;
  const buttonText = isAvailable ? 'Add to Cart' : 'Out of Stock';
  const subscribeButtonText = isAvailable ? 'Subscribe' : 'Out of Stock';
  const buttonOpacity = isAvailable ? '1' : '0.5';
  const buttonCursor = isAvailable ? 'pointer' : 'not-allowed';

  const subscribeButton = customWidget.querySelector('.subscribe-and-save .subscribe-and-save-button');
  const oneTimeButton = customWidget.querySelector('.one-time-purchase .subscribe-and-save-button');

  if (subscribeButton) {
    subscribeButton.disabled = !isAvailable;
    subscribeButton.textContent = subscribeButtonText;
    subscribeButton.style.opacity = buttonOpacity;
    subscribeButton.style.cursor = buttonCursor;
  }

  if (oneTimeButton) {
    oneTimeButton.disabled = !isAvailable;
    oneTimeButton.textContent = buttonText;
    oneTimeButton.style.opacity = buttonOpacity;
    oneTimeButton.style.cursor = buttonCursor;
  }
}

function updateOriginalRechargeWidgetPrices(variant, quantity = 1) {
  const appBlockContainer = document.querySelector('.shopify-block.shopify-app-block.recharge-subscription-widget');
  if (!appBlockContainer) return;

  setTimeout(() => {
    const oneTimePriceLabel = appBlockContainer.querySelector('.onetime-radio .price-label');
    if (oneTimePriceLabel) {
      const oneTimePrice = (variant.price * quantity) / 100;
      const newPriceText = `$${oneTimePrice.toFixed(2)}`;
      if (oneTimePriceLabel.textContent !== newPriceText) {
        oneTimePriceLabel.textContent = newPriceText;
      }
    }

    const subscriptionPriceLabel = appBlockContainer.querySelector('.subscription-radio .price-label');
    if (subscriptionPriceLabel) {
      const subscriptionDiscount = getSubscriptionDiscountPercentage();
      const subscriptionPrice = (variant.price * (1 - subscriptionDiscount) * quantity) / 100;
      const newPriceText = `$${subscriptionPrice.toFixed(2)}`;
      if (subscriptionPriceLabel.textContent !== newPriceText) {
        subscriptionPriceLabel.textContent = newPriceText;
      }
    }

    const rechargeWidget = appBlockContainer.querySelector('.rc-widget');
    if (rechargeWidget) {
      const changeEvent = new CustomEvent('recharge:variant-changed', {
        detail: { variant, quantity }
      });
      rechargeWidget.dispatchEvent(changeEvent);
    }
  }, 100);

  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput && variantInput.value !== variant.id.toString()) {
    variantInput.value = variant.id;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

function getSubscriptionDiscountPercentage() {
  const appBlockContainer = document.querySelector('.shopify-block.shopify-app-block.recharge-subscription-widget');
  if (!appBlockContainer) return 0.1;

  const discountLabel = appBlockContainer.querySelector('.subscription-radio .discount-label');
  if (discountLabel) {
    const discountText = discountLabel.textContent;
    const match = discountText.match(/(\d+)%/);
    if (match) {
      return parseInt(match[1], 10) / 100;
    }
  }
  
  return 0.1;
}

